<template>
  <div class="width-90 paddingLr90 position_relative bg-img flex-column justify-content-start align-items-center">
    <!--    <img class="" src="@/assets/image/bg2.jpg" width="100%" height="100%" alt="" />-->
    <div class="main width-90 paddingLr90 position_absolute">
      <div :class="{ 'from-right': animation2 }" class="width-100 margin-b border-b textAlign-l fw-mid">
        <p class="tit textAlign-c fs-sBig lineHeight2">投资项目</p>
      </div>
      <div class="width-100 flex-row justify-content-start align-items-center flex-wrap">
        <div
          :class="{ 'from-bottom1': animation2 }"
          v-for="(item, index) in project"
          :key="index"
          class="width-33 hover pointer position_relative height230"
        >
          <van-image @click="newsDetail(item.id, 'profile')" :src="imagePrefix + item.poster" width="100%" class="height230" alt="" />
          <p class="fs-big fw-mid white width-90 paddingLr90 position_relative cutText top60" style="text-shadow: #777777 1px 1px 5px">
            {{ item.title }}
          </p>
        </div>
        <img
          class="pointer height230"
          :class="{ 'from-bottom1': animation2 }"
          @click="jumpTo('/profile')"
          src="@/assets/image/p6.jpg"
          width="33%"
          alt=""
        />
      </div>
      <!--      <img class="arrow" src="@/assets/image/arrow1.png" width="3%" alt="" />-->
    </div>
  </div>
</template>
<script>
import config from '@/config';
import newsApi from '@/api/newsApi';

export default {
  name: 'page3',
  components: {},
  props: {
    animation2: Boolean
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      imagePrefix: config.IMAGE_PREFIX,
      project: []
    };
  },
  mounted() {},

  created() {
    newsApi
      .list({ status: '1', params: { pageNum: 1, pageSize: 5, likeType: '015' } })
      .then((res) => {
        this.project = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    newsDetail(id, type) {
      let text = this.$router.resolve({ path: '/newsDetail', query: { type: type, newsId: id } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, query: { Id: m } });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding-top: 2vh;
}
.top60 {
  top: -60px;
}
.height230 {
  height: 230px;
}
.bg-img {
  background: url('../assets/image/bg2.jpg') round;
  background-size: cover;
  height: 100vh;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
}
.tit {
  border-bottom: 3px solid rgb(11, 73, 158);
  width: 90px;
}
//.arrow {
//  margin: 100px 48.5% 0 !important;
//}
.fixed_r {
  top: 50%;
}
.from-bottom1 {
  position: relative;
  animation: bottom 0.8s 0s ease-in-out;
  -moz-animation: bottom 0.8s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom 0.8s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom 0.8s 0s ease-in-out; /* Opera */
}
@keyframes bottom {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}

@-moz-keyframes bottom /* Firefox */ {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}

@-webkit-keyframes bottom /* Safari and Chrome */ {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}

@-o-keyframes bottom /* Opera */ {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}
.from-right {
  position: relative;
  animation: right 1s 0s ease-in-out;
  -moz-animation: right 1s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 1s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 1s 0s ease-in-out; /* Opera */
}
@keyframes right {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-moz-keyframes right /* Firefox */ {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-webkit-keyframes right /* Safari and Chrome */ {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-o-keyframes right /* Opera */ {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}
.hover:hover {
  //width: 35% !important;height: 250px!important;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
</style>
